import { render, staticRenderFns } from "./Letstalk.vue?vue&type=template&id=61250c2c&"
import script from "./Letstalk.vue?vue&type=script&lang=js&"
export * from "./Letstalk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports